import platform from "platform";

/**
 * Detects whether the user is accessing the website from an Android-based
 * device.
 */
export function isAndroid(): boolean {
    return !!(platform.os && platform.os.family === "Android");
}
